import { render, staticRenderFns } from "./summary-box.vue?vue&type=template&id=3c1fe776&"
import script from "./summary-box.vue?vue&type=script&lang=js&"
export * from "./summary-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports